import * as types from "./mutationTypes";

export default {
  [types.SET_DASHBOARDS](state, dashboards) {
    state.dashboards = dashboards;
  },
  [types.CLEAR_DASHBOARDS](state) {
    state.dashboards = null;
  },
  [types.SET_DASHBOARD](state, dashboard) {
    state.dashboard = dashboard;
  },
  [types.CLEAR_DASHBOARD](state) {
    state.dashboard = null;
  },
  [types.SET_NAME](state, name) {
    state.dashboard.name = name;
  },
  [types.REMOVE_DASHBOARD](state, uuid) {
    state.dashboards = state.dashboards.filter((dashboard) => dashboard.uuid !== uuid);
  },
  [types.ADD_DASHBOARD](state, dashboard) {
    state.dashboards.push(dashboard);
  },
  [types.ADD_CHART](state, chart) {
    if (!state.dashboard.charts) {
      state.dashboard.charts = [];
    }
    state.dashboard.charts.push(chart);
  },
  [types.SET_PERIOD](state, { chartUUID, period }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.period = period;
    }
  },
  [types.SET_COMPARE_SURVEYS](state, { chartUUID, isCompareSurveys }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.is_compare_surveys = isCompareSurveys;
    }
  },
  [types.SET_GENERAL_METRIC](state, { chartUUID, generalMetric }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.show_general_metric = generalMetric;
    }
  },
  [types.SET_METRICS](state, { chartUUID, metrics }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.metrics = metrics;
    }
  },
  [types.ADD_METRIC](state, { chartUUID, metric }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      if (!state.dashboard.charts[index].settings.metrics) {
        state.dashboard.charts[index].settings.metrics = [];
      }
      if (!state.dashboard.charts[index].settings.metrics.find((m) => m === metric)) {
        state.dashboard.charts[index].settings.metrics.push(metric);
      }
    }
  },
  [types.SET_SURVEYS](state, { chartUUID, surveys }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.surveys = surveys;
    }
  },
  [types.REMOVE_SURVEY](state, { chartUUID, surveyUUID }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.surveys = state.dashboard.charts[index].settings.surveys.filter(
        (survey) => survey.uuid !== surveyUUID
      );
    }
  },
  [types.SET_COMPOSITE_METRICS](state, { chartUUID, showCompositeMetrics }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.show_composite_metrics = showCompositeMetrics;
    }
  },
  [types.ADD_SELECTED_ITEM](state, { chartUUID, surveyUUID, itemUUID }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      const surveyIndex = state.dashboard.charts[index].settings.surveys.findIndex(
        (survey) => survey.uuid === surveyUUID
      );
      if (surveyIndex != -1) {
        state.dashboard.charts[index].settings.surveys[surveyIndex].selected_items.push(itemUUID);
      }
    }
  },
  [types.REMOVE_SELECTED_ITEM](state, { chartUUID, surveyUUID, itemUUID }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      const surveyIndex = state.dashboard.charts[index].settings.surveys.findIndex(
        (survey) => survey.uuid === surveyUUID
      );
      if (surveyIndex != -1) {
        state.dashboard.charts[index].settings.surveys[surveyIndex].selected_items = state.dashboard.charts[
          index
        ].settings.surveys[surveyIndex].selected_items.filter((item) => item !== itemUUID);
      }
    }
  },
  [types.SET_DESIGN](state, { chartUUID, design }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.design = design;
    }
  },
  [types.SET_CHART_COMPONENT](state, { chartUUID, component }) {
    const index = state.layouts.findIndex((chart) => chart.chartUUID === chartUUID);
    if (index != -1) {
      state.layouts[index].layout.component = component;
    }
  },
  [types.SET_FILTER_DATES](state, { chartUUID, startDate, endDate, range }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      if (!state.dashboard.charts[index].settings) {
        state.dashboard.charts[index].settings = {
          filter: {}
        };
      }
      state.dashboard.charts[index].settings.filter.range = range;
      state.dashboard.charts[index].settings.filter.start_date = startDate;
      state.dashboard.charts[index].settings.filter.end_date = endDate;
    }
  },
  [types.SET_FILTER_CHANNEL](state, { chartUUID, channel }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      if (!state.dashboard.charts[index].settings.filter.channels) {
        state.dashboard.charts[index].settings.filter.channels = [];
      }
      const channelIndex = state.dashboard.charts[index].settings.filter.channels.indexOf(channel);
      if (channelIndex === -1) {
        state.dashboard.charts[index].settings.filter.channels.push(channel);
      } else {
        state.dashboard.charts[index].settings.filter.channels.splice(channelIndex, 1);
      }
    }
  },
  [types.REMOVE_FILTER_CHANNEL](state, { chartUUID, channel }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      if (!state.dashboard.charts[index].settings.filter.channels) {
        state.dashboard.charts[index].settings.filter.channels = [];
      }
      const channelIndex = state.dashboard.charts[index].settings.filter.channels.indexOf(channel);
      if (channelIndex !== -1) {
        state.dashboard.charts[index].settings.filter.channels.splice(channelIndex, 1);
      }
    }
  },
  [types.SET_FILTER_METADATA](state, { chartUUID, metadata }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.filter.metadata = metadata;
    }
  },
  [types.SET_FILTER_ANSWER_STATUS](state, { chartUUID, status }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].settings.filter.answer_status = status;
    }
  },
  [types.SET_LAYOUT](state, { layouts }) {
    const newCharts = [...state.dashboard.charts];

    layouts.forEach(({ index, layout }) => {
      const chart = state.dashboard.charts[index];
      newCharts[index] = { ...chart, layout };
    });

    state.dashboard.charts = newCharts;
  },
  [types.SET_CHART_NAME](state, { chartUUID, name }) {
    const index = state.dashboard.charts.findIndex((chart) => chart.uuid === chartUUID);
    if (index != -1) {
      state.dashboard.charts[index].name = name;
    }
  },
  [types.REMOVE_CHART](state, chartUUID) {
    const index = state.dashboard.charts.findIndex((chartDash) => chartDash.uuid === chartUUID);
    state.dashboard.charts.splice(index, 1);
    state.layouts.splice(index, 1);
  },
  [types.UPDATE_CHART](state, chart) {
    if (state.dashboard && state.dashboard.charts) {
      const index = state.dashboard.charts.findIndex((chartDash) => chartDash.uuid === chart.uuid);
      Object.assign(state.dashboard.charts[index], chart);
    }
  },
  [types.UPDATE_CHART_LAYOUT](state, { layouts }) {
    state.dashboard.layouts = layouts;
    state.layouts = layouts;
  },
  [types.SET_CHARTS](state, charts) {
    state.dashboard.charts = charts;
  }
};
